<div class="articles-section mt-2">
    <div class="mb-12">
        <div *ngIf="!dataTypeIsGyan">
            <div
                *ngIf="articles && articles.length < 40 && disabledLoadMoreLink === undefined && userSignIn"
                class="text-decoration-underline font-16 find-more-articles padding-r-20"
                (click)="moveToAdvanceSearch()"
                [ngClass]="articleExpanded ? 'text-start float-start' : 'text-end float-end'"
                [attr.id]="'find-more-articles'"
                [attr.data-test]="'find-more-articles'"
            >
                Find More Articles
            </div>
            <div
                *ngIf="articles && articles.length < 40 && disabledLoadMoreLink === undefined && !userSignIn"
                class="text-end text-decoration-underline font-16 find-more-articles-disabled padding-r-20"
                [ngClass]="articleExpanded ? 'text-start float-start' : 'text-end float-end'"
                [attr.id]="'find-more-articles'"
                [attr.data-test]="'find-more-articles'"
            >
                Find More Articles
            </div>

            <div
                *ngIf="((articles && articles.length >= 40) || disabledLoadMoreLink) && !userSignIn"
                class="text-end text-decoration-underline font-16 find-more-articles-disabled padding-r-20"
                [ngClass]="articleExpanded ? 'text-start float-start' : 'text-end float-end'"
                [attr.id]="'find-more-articles'"
                [attr.data-test]="'find-more-articles'"
            >
                Find More Articles
            </div>
            <div
                *ngIf="((articles && articles.length >= 40) || disabledLoadMoreLink) && userSignIn"
                class="text-end text-decoration-underline font-16 find-more-articles padding-r-20"
                (click)="showSubscriptionMessageModal()"
                [ngClass]="articleExpanded ? 'text-start float-start' : 'text-end float-end'"
                [attr.id]="'find-more-articles'"
                [attr.data-test]="'find-more-articles'"
            >
                Find More Articles
            </div>
            <div class="clear"></div>
        </div>
        <div *ngIf="dataTypeIsGyan">
            <div *ngIf="articles && articles.length > 0" class="font-16 padding-r-15" [ngClass]="articleExpanded ? 'text-start float-start' : 'text-start float-start'">
                Relevant Articles ({{ articles.length }})
            </div>
            <div class="clear"></div>
        </div>
    </div>

    <div class="h-100" *ngIf="!dataTypeIsGyan">
        <div class="article-list" [ngClass]="articleExpanded ? 'without-searchbar' : 'with-searchbar'">
            <!-- <ng-scrollbar visibility="hover" [pointerEventsDisabled]="false" #articleListDiv> -->

            <ng-container *ngIf="enableRapidScroll; else withoutScroll">
                <!-- wihtout scroll means clicking on para-->
                <div
                    class="search-results position-relative"
                    infiniteScroll
                    [infiniteScrollDistance]="2"
                    [infiniteScrollThrottle]="150"
                    (scrolled)="findMoreArticles()"
                    [scrollWindow]="false"
                    #articleListDiv
                >
                    <ng-container *ngTemplateOutlet="content"></ng-container>
                </div>
            </ng-container>

            <ng-template #withoutScroll>
                <div class="search-results position-relative" #articleListDiv>
                    <ng-container *ngTemplateOutlet="content"></ng-container>
                </div>
            </ng-template>

            <!-- </ng-scrollbar> -->
        </div>
    </div>

    <div *ngIf="dataTypeIsGyan">
        <div class="article-list" [ngClass]="articleExpanded ? 'without-searchbar' : 'with-searchbar'">
            <div
                class="search-results position-relative"
                infiniteScroll
                [infiniteScrollDistance]="2"
                [infiniteScrollThrottle]="150"
                (scrolled)="enableScroll ? onScrollArticleList() : ''"
                [scrollWindow]="false"
                #articleListDiv
            >
                <app-article *ngIf="articles" [articles]="articles" [articleNotAvailable]="articleNotAvailable" [loading]="loading" [sentenceIds]="sentenceIds"></app-article>
                <div *ngIf="!articles">
                    <div class="article-skeleton">
                        <div class="article-url-placeholder skeleton-placeholder"></div>
                        <!-- <div class="article-url-source-placeholder skeleton-placeholder"></div> -->
                        <div class="article-title-placeholder skeleton-placeholder"></div>
                        <div class="article-para-placeholder skeleton-placeholder"></div>
                        <div class="article-more-content-placeholder skeleton-placeholder"></div>
                    </div>
                    <div class="article-skeleton">
                        <div class="article-url-placeholder skeleton-placeholder"></div>
                        <!-- <div class="article-url-source-placeholder skeleton-placeholder"></div> -->
                        <div class="article-title-placeholder skeleton-placeholder"></div>
                        <div class="article-para-placeholder skeleton-placeholder"></div>
                        <div class="article-more-content-placeholder skeleton-placeholder"></div>
                    </div>
                    <div class="article-skeleton">
                        <div class="article-url-placeholder skeleton-placeholder"></div>
                        <!-- <div class="article-url-source-placeholder skeleton-placeholder"></div> -->
                        <div class="article-title-placeholder skeleton-placeholder"></div>
                        <div class="article-para-placeholder skeleton-placeholder"></div>
                        <div class="article-more-content-placeholder skeleton-placeholder"></div>
                    </div>
                    <div class="article-skeleton">
                        <div class="article-url-placeholder skeleton-placeholder"></div>
                        <!-- <div class="article-url-source-placeholder skeleton-placeholder"></div> -->
                        <div class="article-title-placeholder skeleton-placeholder"></div>
                        <div class="article-para-placeholder skeleton-placeholder"></div>
                        <div class="article-more-content-placeholder skeleton-placeholder"></div>
                    </div>
                    <div class="article-skeleton">
                        <div class="article-url-placeholder skeleton-placeholder"></div>
                        <!-- <div class="article-url-source-placeholder skeleton-placeholder"></div> -->
                        <div class="article-title-placeholder skeleton-placeholder"></div>
                        <div class="article-para-placeholder skeleton-placeholder"></div>
                        <div class="article-more-content-placeholder skeleton-placeholder"></div>
                    </div>
                    <!-- Display the below div only if there is no article -->
                    <div
                        [ngClass]="{
                            'no-article-message-mobile': isMobile && gyanType === 'rapid',
                            'no-article-message': !isMobile && gyanType === 'rapid',
                            'no-article-message-gyan': !isMobile && gyanType === 'gyan',
                            'no-article-message-gyan-mobile': isMobile && gyanType === 'gyan',
                        }"
                        *ngIf="articleNotAvailable"
                    >
                        Articles not found
                    </div>
                    <div
                        class="d-flex"
                        [ngClass]="{
                            'loading-article-message-mobile': isMobile && gyanType === 'rapid',
                            'loading-article-message': !isMobile && gyanType === 'rapid',
                            'loading-article-message-gyan': !isMobile && gyanType === 'gyan',
                            'loading-article-message-gyan-mobile': isMobile && gyanType == 'gyan',
                        }"
                        *ngIf="!articleNotAvailable"
                    >
                        <div class="padding-summary">Loading Articles</div>
                        <div><img src="./../../../assets/gifs/loader_sand.gif" alt="Processing icon" /></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #content>
    <app-article *ngIf="articles" [articles]="articles" [articleNotAvailable]="articleNotAvailable" [loading]="loading" [sentenceIds]="sentenceIds"></app-article>
    <div *ngIf="!articles">
        <div class="article-skeleton">
            <div class="article-url-placeholder skeleton-placeholder"></div>
            <!-- <div class="article-url-source-placeholder skeleton-placeholder"></div> -->
            <div class="article-title-placeholder skeleton-placeholder"></div>
            <div class="article-para-placeholder skeleton-placeholder"></div>
            <div class="article-more-content-placeholder skeleton-placeholder"></div>
        </div>
        <div class="article-skeleton">
            <div class="article-url-placeholder skeleton-placeholder"></div>
            <!-- <div class="article-url-source-placeholder skeleton-placeholder"></div> -->
            <div class="article-title-placeholder skeleton-placeholder"></div>
            <div class="article-para-placeholder skeleton-placeholder"></div>
            <div class="article-more-content-placeholder skeleton-placeholder"></div>
        </div>
        <div class="article-skeleton">
            <div class="article-url-placeholder skeleton-placeholder"></div>
            <!-- <div class="article-url-source-placeholder skeleton-placeholder"></div> -->
            <div class="article-title-placeholder skeleton-placeholder"></div>
            <div class="article-para-placeholder skeleton-placeholder"></div>
            <div class="article-more-content-placeholder skeleton-placeholder"></div>
        </div>
        <div class="article-skeleton">
            <div class="article-url-placeholder skeleton-placeholder"></div>
            <!-- <div class="article-url-source-placeholder skeleton-placeholder"></div> -->
            <div class="article-title-placeholder skeleton-placeholder"></div>
            <div class="article-para-placeholder skeleton-placeholder"></div>
            <div class="article-more-content-placeholder skeleton-placeholder"></div>
        </div>
        <div class="article-skeleton">
            <div class="article-url-placeholder skeleton-placeholder"></div>
            <!-- <div class="article-url-source-placeholder skeleton-placeholder"></div> -->
            <div class="article-title-placeholder skeleton-placeholder"></div>
            <div class="article-para-placeholder skeleton-placeholder"></div>
            <div class="article-more-content-placeholder skeleton-placeholder"></div>
        </div>
        <!-- Display the below div only if there is no article -->
        <div
            [ngClass]="{
                'no-article-message-mobile': isMobile && gyanType === 'rapid',
                'no-article-message': !isMobile && gyanType === 'rapid',
                'no-article-message-gyan': !isMobile && gyanType === 'gyan',
                'no-article-message-gyan-mobile': isMobile && gyanType == 'gyan',
            }"
            *ngIf="articleNotAvailable"
        >
            Articles not found
        </div>
        <div
            class="d-flex"
            [ngClass]="{
                'loading-article-message-mobile': isMobile && gyanType === 'rapid',
                'loading-article-message': !isMobile && gyanType === 'rapid',
                'loading-article-message-gyan': !isMobile && gyanType === 'gyan',
                'loading-article-message-gyan-mobile': isMobile && gyanType == 'gyan',
            }"
            *ngIf="!articleNotAvailable"
        >
            <div class="padding-summary">Loading Articles</div>
            <div><img src="./../../../assets/gifs/loader_sand.gif" alt="Processing icon" /></div>
        </div>
    </div>
</ng-template>
